exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ol li[data-v-3b2284e4]::marker{font-weight:400}li[data-v-3b2284e4]{font-weight:300}", ""]);

// exports
